module.exports = __webpack_public_path__ + "img/icon06.0fba6d83.png";